import { getDbmsTypes } from '@/api';
import { CdmDataSourceDTO, DBMSTypesDTO } from '@/types';
import { parseDbmsTypesForSelectForm } from '@/utils';
import {
  Block,
  Grid,
  Typography,
  EditableSelect,
  EditableInput,
} from '@prometheus/components';
import { Documents } from '@prometheus/documents';
import { FormLabel } from '@prometheus/features';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const ConnectionDetails: FC<{
  entity: CdmDataSourceDTO;
  updateEntity: (entity: any, file?: any) => void;
}> = ({ entity, updateEntity }) => {
  const { t } = useTranslation();
  const [dbsmTypes, setDbsmTypes] = useState([]);
  useEffect(() => {
    getDbmsTypes().then((res: DBMSTypesDTO) => {
      setDbsmTypes(parseDbmsTypesForSelectForm(res));
    });
  }, []);
  return (
    <Block>
      <Grid container spacing={2} item xs={12} p={2}>
        <Grid item xs={12} sm={6} container spacing={2}>
          <FormLabel
            htmlFor="database-type"
            label={t('forms.dbms_type')}
            required
          >
            <EditableSelect
              value={entity.type}
              className=""
              fullWidth
              id="database-type"
              options={dbsmTypes}
              placeholder={t('forms.dbms_type_placeholder')}
              size="small"
              onSubmit={
                (newVal: any) => {
                  updateEntity({ ...entity, type: newVal });
                }
                // updateFiled('type', newVal)
              }
              sx={{ ml: -1 }}
              onCancel={() => {}}
            />
          </FormLabel>

          <FormLabel
            htmlFor="connection-string"
            label={t('forms.connection_string')}
            required
          >
            <EditableInput
              value={entity.connectionString}
              className=""
              fullWidth
              id="connection-string"
              placeholder={t('forms.connection_string_placeholder')}
              size="small"
              onSubmit={(newVal: any) => {
                updateEntity({
                  ...entity,
                  connectionString: newVal,
                });
              }}
              sx={{ ml: -1 }}
              onCancel={() => {}}
              color="textColor.primary"
              required
            />
          </FormLabel>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          container
          spacing={2}
          alignContent="flex-start"
        >
          {entity.type !== 'bigquery' ? (
            <>
              <FormLabel
                htmlFor="username"
                label={t('forms.username')}
                required
              >
                <EditableInput
                  value={entity.credentials.username}
                  className=""
                  fullWidth
                  id="username"
                  placeholder={t('forms.username_placeholder')}
                  size="small"
                  onSubmit={(newVal: any) => {
                    updateEntity({
                      ...entity,
                      credentials: {
                        ...entity.credentials,
                        username: newVal,
                      },
                    });
                  }}
                  sx={{ ml: -1 }}
                  onCancel={() => {}}
                  color="textColor.primary"
                  required
                />
              </FormLabel>

              <FormLabel
                htmlFor="password"
                label={t('forms.password')}
                required
              >
                <EditableInput
                  value={entity.credentials.password}
                  className=""
                  fullWidth
                  id="password"
                  type="password"
                  placeholder={t('forms.password_placeholder')}
                  size="small"
                  onSubmit={(newVal: any) => {
                    updateEntity({
                      ...entity,
                      credentials: {
                        ...entity.credentials,
                        password: newVal,
                      },
                    });
                  }}
                  sx={{ ml: -1 }}
                  onCancel={() => {}}
                  color="textColor.primary"
                  required
                />
              </FormLabel>
            </>
          ) : (
            <Grid item xs={12}>
              <Documents
                type="component"
                name="import-json-file"
                config={
                  {
                    titleButton: t('buttons.upload_keyfile'),
                    initialTextFile: entity?.keyfileName,
                    onChange: (parsedJson: any, file: any) => {
                      updateEntity(entity, file);
                    },
                    required: true,
                  } as any
                }
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Block>
  );
};
